module.exports = __webpack_public_path__ + "static/media/cloudpayments.200a0f89.png";